<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsEstadoCivil"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsEstadoCivil"
          addFilter
          :items="listarEstadoCivil"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editEstadoCivil"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="estadocivil.id === 0 ? addSexo() : editandoSexo()" autocomplete="off">
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="estadocivil.descricao">Descrição</fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Estado civil',
      titleModal: '',
      titlePDF: 'Estado civil',
      listarEstadoCivil: [],
      baseUrlGestaoProjetosConcurso: '',
      estadocivil: [],
      itemPorPage: '100',
      actionsEstadoCivil: [
        {
          button: true,
          funcaoButton: 'editEstadoCivil',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteSexo',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsEstadoCivil: [
        { key: 'idestadocivil', label: 'ID', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    listandoSexo() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'EstadoCivil/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarEstadoCivil = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField() {
      this.titleModal = 'Adicionar Estado civil'
      this.estadocivil = {}
      this.estadocivil.id = 0
      this.$root.$emit('bv::show::modal', 'editEstadoCivil')
    },
    editEstadoCivil(_, item) {
      this.titleModal = 'Editar Estado civil'
      this.estadocivil = item
      this.$root.$emit('bv::show::modal', 'editEstadoCivil')
    },
    editandoSexo() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'EstadoCivil/Alterar',
          this.estadocivil,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.estadocivil = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editEstadoCivil')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addSexo() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'EstadoCivil/Adicionar',
          this.estadocivil,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.estadocivil = {}
          this.listandoSexo()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editEstadoCivil')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteSexo(_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'EstadoCivil/Excluir/' + item.idestadocivil,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoSexo()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted() {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.listandoSexo()
  }
}
</script>
